jQuery(document).ready(function($) {
    
    console.log('payment js start');

    const PAYMENT_THRESHOLD_MONTHS = 3; // Change this to adjust the future booking requirement

    const $select = $('#payment_option');
    const $hiddenDate = $('#selected_booking_date');

    let lastBookingDate = null;
    let debounceTimer = null;

    function updatePaymentOptions(bookingDateString) {
        if (!bookingDateString || bookingDateString === lastBookingDate) return;
        lastBookingDate = bookingDateString;

        const bookingDate = new Date(bookingDateString);
        const today = new Date();
        const thresholdDate = new Date(today);
        thresholdDate.setMonth(today.getMonth() + PAYMENT_THRESHOLD_MONTHS);

        console.log('[Booking Payment]', {
            bookingDateString,
            parsedBookingDate: bookingDate,
            today,
            thresholdDate,
            isFutureBooking: bookingDate > thresholdDate
        });

        $select.empty().append('<option value="">Select a payment option</option>');

        if (bookingDate > thresholdDate) {
            $select.append('<option value="pay_in_full">Pay in Full</option>');
            $select.append('<option value="book_now_pay_later">Book Now, Pay Later - Deposit Required</option>');
            $select.append('<option value="payment_installments">Payment Instalments - Deposit Required</option>');
        } else {
            $select.append('<option value="pay_in_full">Pay in Full</option>');
        }

        $hiddenDate.val(bookingDateString);
    }

    function bindBookingInput() {
        const $fromDateInput = $('input[name="from"]');

        if ($fromDateInput.length) {
            // Remove previous handler to prevent stacking
            $fromDateInput.off('change.bookingwatch').on('change.bookingwatch', function () {
                const val = $(this).val();
                if (val) {
                    clearTimeout(debounceTimer);
                    debounceTimer = setTimeout(() => {
                        updatePaymentOptions(val);
                    }, 100);
                }
            });

            // Trigger once on load
            const val = $fromDateInput.val();
            if (val) updatePaymentOptions(val);
        }
    }

    // Run once initially
    bindBookingInput();

    // Observer to re-bind if calendar fields reload
    const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            bindBookingInput();
        }, 200);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    console.log('payment js end');
});


/* booking ajax override */
jQuery(document).ready(function($) {
    $('#payment_option').on('change', function () {
        $('body').trigger('update_checkout');
    });
});